function clear_tokens() {
	localStorage.removeItem("token");
	localStorage.removeItem("refresh_token");
	localStorage.removeItem("token_time");

	window.location.href = "/login/";
}

export default clear_tokens;
